/* eslint-disable no-unexpected-multiline */
import { type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'

const axios = axiosInstance()

export const getContent = async (args: {
  apiConfigs: APIConfig
  channelId: string
}): Promise<Record<PropertyKey, any>> => {
  const { assetsOriginBaseUrl } = args.apiConfigs

  const filename = (() => {
    switch (args.channelId) {
      case '2':
        return 'content_sv_SE_BYME.json'
      // Prepare for BM NO Garden Buildings
      // case '9':
      //   return '...'
      default:
        return 'content_sv_SE_SKBV.json'
    }
  })()

  const response =
    import.meta.env.MODE === 'development'
      ? await import.meta
          .glob('../../../../content/*.json')
          [`../../../../content/${filename}`]()
          .then((mod) => ({
            data: (mod as any).default,
          }))
          .catch((error) => {
            console.error(error)
            throw new Error(JSON.stringify(error))
          })
      : await axios({
          method: 'get',
          url: `${assetsOriginBaseUrl}/${filename}`,
        }).catch((error) => {
          console.error(error)
          throw new Error(JSON.stringify(error))
        })

  return response.data
}
